export default "__VITE_ASSET__BWkAWRYh__"